import React, { } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from '../index.module.css';
import Logo from '../../../assets/images/brand/lotto_logo.png';
import ToggleIcon from '../../../assets/images/icons/toggle_icon.png';
import ViewerRoutes from "../../../routes/ViewerRoutes";

const ViewerSidebar = ({ isSidebarOpen, closeSidebar }) => {
    const location = useLocation(); // Get the current location
    const slicedRoutes = ViewerRoutes.slice(0, 10);

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.sidebarLogo}>
                    <img src={ToggleIcon} className={styles.toggleBtn} alt="toggle" onClick={closeSidebar} />
                    <img src={Logo} alt="Logo" className={styles.logoImage} />
                </div>
                <ul className={styles.sidebarMenu}>
                    {slicedRoutes.map((item, index) => (
                        <li
                            key={index}
                            className={location.pathname === `/viewer/${item.path}` ||
                                location.pathname.startsWith(`/viewer/${item.path}/`) ? styles.active : ""} // Add 'active' class
                            onClick={closeSidebar}
                        >
                            <Link to={`/viewer/${item.path}`} className={styles.linkText}>
                                <img src={location.pathname === `/viewer/${item.path}` ||
                                    location.pathname.startsWith(`/viewer/${item.path}/`) ? item.icon : item.inactiveIcon}
                                    className={styles.sidebarIcon}
                                    alt="Icon" />
                                <span>{item.name}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default ViewerSidebar;
